module.exports = __webpack_public_path__ + "static/media/profile.28507948.jpeg";